<template>
    <CascoAjanlatBase :titleExtra="titleExtra"  v-if="false">

            <v-form ref="casco-ajanlat-adatok" slot="biztositoi-adatok">

                <v-layout row wrap>

                </v-layout>

            </v-form>

    </CascoAjanlatBase>

</template>

<script>
import CascoAjanlatBase from '../CascoAjanlatBase.vue';
import cascoOfferData from '../../../../../mixins/ajanlatiadatok/biztosito_specifikus/CascoOfferData';

export default {
    components: { CascoAjanlatBase },
    mixins: [cascoOfferData],
    methods: {},
    data() {
        return {
            name: 'AjanlatAdatokB10_V0',
            version: 'v0',
        };
    },
};
</script>
